<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Weitere Informationen"}}</h4>
</div>

<div class="modal-body">
	{{ERROR_ROW errors.error}}
	{{#each formData.fields}}
	<div class="row m-b-10">
		<div class="col-sm-4">
			<input {{#if ../restricted}} readonly {{/if}} class="form-control font-bold {{#if this.error_name}}parsley-error{{/if}}" name="name-{{@index}}" type="text" value="{{name}}" placeholder={{TR "Name" }}>
			{{#if this.error_name}}
			<ul class="parsley-errors-list filled" id="js-name-{{@index}}-error">
				<li class="parsley-required">{{TR "Name ist"}} {{TR this.error_name}}</li>
			</ul>
			{{/if}}
		</div>
		<div class="col-sm-7">
			{{#if this.isTextArea}}
				<textarea class="form-control {{#if this.error_value}}parsley-error{{/if}}" name="value-{{@index}}-textarea" cols="40" rows="6">{{value}}</textarea>
			{{else}}
				<input class="form-control {{#if this.error_value}}parsley-error{{/if}}" name="value-{{@index}}-textline" type="text" value="{{value}}" placeholder={{TR "Wert"}}>
			{{/if}}
			{{#if this.error_value}}
			<ul class="parsley-errors-list filled" id="js-value-{{@index}}-error">
				<li class="parsley-required">{{TR "Eintrag ist"}} {{TR this.error_value}}</li>
			</ul>
			{{/if}}
		</div>
		{{#unless ../restricted}}
		<div class="col-sm-1">
			<button data-idx="{{@index}}" id="js-field-{{@index}}" class="btn btn-small btn-white pull-right js-delete">
				<i class="fa fa-trash"></i>
			</button>
		</div>
		{{/unless}}
	</div>
	{{/each}}

	{{#unless restricted}}
	<div class="dropdown m-t-30">
		<button class="btn btn-white dropdown-toggle" type="button" data-toggle="dropdown">{{TR "Neues Feld"}}
		<span class="caret"></span></button>
		<ul class="dropdown-menu">
			<li><a class="js-add-field-line" href="#">{{TR "Einzeilig"}}</a></li>
			<li><a class="js-add-field-text" href="#">{{TR "Mehrzeilig"}}</a></li>
		</ul>
	</div>
	{{/unless}}
</div>

<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white js-cancel" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
